/** @format */
import {
    AttributeKey,
    ProductConditionValue,
} from '@toucan/client/global/product/config/product';

export type LegacyProductImage = {
    alt: string;
    url: string | null;
    product: string;
    image: string;
    imageUrl: string;
    thumb: string;
    ordering: number;
    meta?: any;
};

export type InternalMediaServiceImage = {
    id: number;
    timeAdded: string;
    addedBy: number;
    alt: string;
    index: number;
    title: string;
    fid: string;
    fileKeyCookie: string;
    url: string;
    volumeId: string | null;
};

export type Observation = {
    code: string;
    observationDescription: string;
    observationId: number;
    tierDescription: string;
    tierShortDescription: string;
    tierId: number;
    tierTitle: string;
};

export type PriceModifier = {
    id: number;
    name: string;
    core: boolean;
    essential: boolean;
    present: boolean;
};

export enum ProductState {
    SHIPPED = 'Shipped',
    ONLINE = 'Online',
    OFFLINE = 'Offline',
    ALLOCATED = 'Allocated',
}

export type ProductSummaryAttribute = {
    name: AttributeKey;
    content: string;
};

type Product = {
    id: number;
    modelId: number;
    sku: string;
    fullSku: string;
    name: string;
    images: LegacyProductImage[];
    condition: ProductConditionValue;
    state: ProductState;
    listPrice: string;
    modelName: string;
};

type ProductInjectedFields = {
    // The following are not returned from the product service
    // but are created when we serialize the data
    value: number;
    name: string;
    modelName: string;
    isSold?: boolean;
};

export type ProductSummaryV2 = {
    description: string;
    conditionDescription: string;
    customDescription: string;
    hasCustomDescription: boolean;
    priceModifiers: PriceModifier[];
    attributes: ProductSummaryAttribute[];
    discount: string;
    discountIsPercentage: boolean;
    primaryCategoryName: string;
    internalImages: LegacyProductImage[];
    observations: Observation[];
    productPriceOriginal: string;
} & Product &
    ProductInjectedFields;
